module.exports = __webpack_public_path__ + "static/img/21b.44a401c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/21b.jpg
// module id = IRjB
// module chunks = 1